import { Directive } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalHtmlDirective } from './modal-html.directive';

@Directive({
  selector: '[appPrivacyPolicy]'
})
export class PrivacyPolicyDirective extends ModalHtmlDirective {

  constructor(protected modal: ModalController) {
    super(modal);

    this.titleKey = 'PRIVACY_POLICY';
    this.contentKeys = ['PRIVACY_POLICY_TEXT'];
  }

}
